<div mat-dialog-content class="message-content">
    <h3 i18n="@@configurator.login.welcome">Welcome back, {{ emailAddress }}</h3>
    <img alt="" class="animated-image" src="assets/images/login/mail-sent.gif" />
    <h1 i18n="@@configurator.login.title">You've got mail</h1>
    <div class="description" i18n="@@configurator.login.description">
        Please go to your e-mail and click the link to continue with the configuration.
    </div>
</div>
